// Informações de contato centralizadas
export const CONTACTS = {
  phone: '+5521967611301',
  phoneDisplay: '(21) 96761-1301',
  whatsappUrl: 'https://wa.me/5521967611301',
  email: 'contato@nutriaron.com',
  instagram: 'https://instagram.com/nutriaron',
  instagramHandle: '@nutriaron',
  location: 'Rio de Janeiro, RJ',
};

// Google Analytics (preparado para adicionar ID futuramente)
export const GOOGLE_ANALYTICS_ID = ''; // Adicione seu ID aqui quando disponível

export const BUSINESS_HOURS = {
  weekdays: 'Segunda a Sexta',
  hours: '9h às 18h',
};
